module.exports = __webpack_public_path__ + "img/barbados.3a0d90d.webp";